////
/// ============================================================================
/// COMPONENT / PhotoSwipe
/// ============================================================================
///
/// @group components
////

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

export default () => {
    let element = document.querySelector('.js-lightbox');

    if (!element) {
        return;
    }

    // Photoswipe
    const zoom = '<svg aria-hidden="true" class="pswp__icn"><use xlink:href="' + m6e.spriteUrl + '#icon--search"></use></svg>';
    const close = '<svg aria-hidden="true" class="pswp__icn"><use xlink:href="' + m6e.spriteUrl + '#icon--close"></use></svg>';
    const arrow = '<svg aria-hidden="true" class="pswp__icn"><use xlink:href="' + m6e.spriteUrl + '#icon--arrow"></use></svg>';

    const options = {
        arrowNextSVG: arrow,
        arrowPrevSVG: arrow,
        children: 'a',
        closeSVG: close,
        gallery: '.js-lightbox',
        loop: false,
        padding: { top: 20, bottom: 20, left: 20, right: 20 },
        preload: [1, 4],
        zoomSVG: zoom,

        arrowPrevTitle: 'Immagine precedente',
        arrowNextTitle: 'Immagine successiva',
        closeTitle: 'Chiudi',
        errorMsg: 'Immagine non caricata',
        indexIndicatorSep: ' di ',

        pswpModule: () => import('photoswipe'),
    };

    const lightbox = new PhotoSwipeLightbox(options);

    lightbox.on('openingAnimationStart', () => {
        let zIndex = 0;
        document.body.childNodes.forEach(node => {
            if (node instanceof Element) {
                const style = getComputedStyle(node);
                const nodeZIndex = parseInt(style.zIndex);

                // zIndex can be a string like "auto", "inherit" or "initial"
                // @link https://developer.mozilla.org/en-US/docs/Web/CSS/z-index
                if (isNaN(nodeZIndex)) {
                    return;
                }

                if (nodeZIndex > zIndex) {
                    zIndex = nodeZIndex;
                }
            }
        });

        lightbox.pswp.element.style.zIndex = ++zIndex + "";
    });

    new PhotoSwipeDynamicCaption(lightbox, {
        type: 'auto',
    });

    lightbox.init();
};
